import React from "react";

export default ({ loading, handleLoadMore, isLast }) => (
    <div className="text-center btn-wrapper">
        {!isLast && (
            <a
                className="button light"
                disabled={loading}
                onClick={handleLoadMore}
            >
                {loading ? "Loading..." : "Load more"}
            </a>
        )}
    </div>
);
